import { toDateOnly } from '@voll-intelligence/dates';
import { fmtDayMonth } from '../../../flight/results/flight_format.js';
import type { CheckoutHotelCopy } from '../../model/checkout_copy.js';
import type { HotelItemSource } from '../../model/checkout_source.js';

/** A frase de cancelamento que o bloco «Hospedagem» do card do chat e o painel
 *  do drawer dividem. */

/** A condição de cancelamento do item, escrita — a MESMA frase na régua do
 *  bloco e no painel do drawer. Não reembolsável vence qualquer data; o prazo
 *  sem multa só é dito enquanto está no futuro (no próprio dia a multa já
 *  começou, mesma régua da lista de quartos); sem prazo fica o `refundable`
 *  tri-estado — sem o campo nada é dito (regra dos agregados de tarifa). */
export function hotelCancellationLabel(
  detail: HotelItemSource['detail'],
  copy: CheckoutHotelCopy,
  locale: string,
): { text: string; charged: boolean } | undefined {
  if (detail.refundable === false) {
    return { text: copy.nonRefundable, charged: true };
  }
  // Today in the reader's runtime time zone (`toDateOnly` reads local getters).
  if (detail.freeCancellationUntil && detail.freeCancellationUntil > toDateOnly(new Date())) {
    return {
      text: copy.freeCancelUntil(fmtDayMonth(detail.freeCancellationUntil, locale)),
      charged: false,
    };
  }
  return detail.refundable ? { text: copy.refundable, charged: false } : undefined;
}
